import React from 'react';
import styled from 'styled-components';
import AccountButton from './AccountButton';
import BuyHunnyButton from './BuyHunnyButton';
import LanguageSelect from './LanguageSelect';

const BottomBar: React.FC = () => {
	return (
		<StyledBottomBar className="content-blurable">
			<StyledLeftSide>
				<AccountButton />
			</StyledLeftSide>
			<StyledRightSide>
				<StyledBuyHunnyContainer>
					<BuyHunnyButton includeIcon />
				</StyledBuyHunnyContainer>
			</StyledRightSide>
		</StyledBottomBar>
	);
};

const StyledBottomBar = styled.div`
	left: 0px;
	bottom: 0px;
	position: fixed;
	display: none;

	justify-content: space-between;

	align-items: center;
	width: 100vw;
	box-sizing: border-box;
	z-index: 6;

	background: rgba(0, 0, 0, 0.2);
	backdrop-filter: blur(10px);

	@media (max-width: 1170px) {
		display: flex;
		padding: 0 16px;
	}

	@media (max-width: 335px) {
		justify-content: center;
	}
`;

const StyledLeftSide = styled.div`
	min-height: 56px;
	display: flex;
	align-items: center;
	position: relative;
	max-width: 250px;
	width: 100%;
	@media (max-width: 590px) {
		height: 40px;
	}

	@media (max-width: 1170px) {
		& .balance,
		& .address {
			display: flex;
			align-items: center;
		}
	}
`;

const StyledRightSide = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const StyledBuyHunnyContainer = styled.div`
	@media (max-width: 600px) {
		display: flex;
	}

	@media (max-width: 335px) {
		display: none;
	}
`;

const StyledLanguageSelect = styled.div``;

export default BottomBar;
